import { render, staticRenderFns } from "./MediaAndOverlay.vue?vue&type=template&id=0e2493f6&scoped=true&name=media-and-overlay&"
import script from "./MediaAndOverlay.vue?vue&type=script&lang=js&"
export * from "./MediaAndOverlay.vue?vue&type=script&lang=js&"
import style0 from "./MediaAndOverlay.vue?vue&type=style&index=0&id=0e2493f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2493f6",
  null
  
)

export default component.exports